import { Breakpoints, BreakpointWrapper } from "@volkswagen-onehub/components-core";
import React from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import ShareList from "../components/ShareList";
import { ViewToggle } from "../components/TopBar/View";
import FavouritesHeader from "./FavouritesHeader";

type BarContainerType = {
  spaceBetween?: boolean;
};

const TopBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: var(--size-dynamic0050);
`;

const BarContainer = styled.div<BarContainerType>`
  margin: 0 var(--size-grid002) var(--size-dynamic0140);
  max-width: 1750px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: end;
  column-gap: var(--size-dynamic0050);
  row-gap: 8px;
  border-bottom: 1px solid rgb(223, 228, 232);
`;

const ActionContainer = styled.div`
  display: flex;
  column-gap: var(--size-dynamic0050);
  align-items: center;
`;

export default () => {
  const params = useParams();

  return (
    <TopBarContainer>
      <BarContainer>
        <FavouritesHeader />
        <ActionContainer>
          {params?.ulid ? null : <ShareList />}
          <BreakpointWrapper min={Breakpoints.b960}>
            <ViewToggle />
          </BreakpointWrapper>
        </ActionContainer>
      </BarContainer>
    </TopBarContainer>
  );
};
